export default __webpack_public_path__ + "static/samsung-pay-7b8a6ed14a5244f8cf624dc10a6c0156.svg";